import React, { useEffect, useState } from "react";
import { LoginPart } from "../../../../public/loginPage/login";
import CustomDialog from "../../../../../components/custom/dialog";
import {
  useAppDispatch,
  useAppSelector,
} from "../../../../../../app/redux/hooks";
import CustomButton from "../../../../../components/custom/button";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import { setStepperActiveMenu } from "../../../../../../app/slices/checkoutSlice/CheckoutSlice";
import CustomInput from "../../../../../components/custom/input";
import { FormControl, FormLabel, RadioGroup, Tooltip } from "@mui/material";
import {
  emailVarificationAsync,
  getProfileDataAsync,
  updateProfileDataAsync,
} from "../../../../../../app/slices/profileSlice/ProfileSlice";
import { ChangeEmail } from "../../../profilePage/components/settings/ChangeEmail";
import { showSnackbar } from "../../../../../../app/slices/common/customSnackBar/customSnackbarSlice";
import {
  AccountDetailsValidation,
  AccountNameDetailsValidation,
} from "../../../profilePage/components/validations/accountDetailsValidation";
import { AccountDetailsValues } from "../../../profilePage/components/ProfilePageTypes";
import { CheckCircleOutline } from "@mui/icons-material";
import InfoIcon from "@mui/icons-material/Info";
import TaskAltIcon from "@mui/icons-material/TaskAlt";
import PublishedWithChangesIcon from "@mui/icons-material/PublishedWithChanges";
import SaveIcon from "@mui/icons-material/Save";
export const AccountSection = () => {
  const initialState: AccountDetailsValues = {
    phone_number: "+91 ",
    first_name: "",
    last_name: "",
    email: "",
    gender: "",
    dob: "",
  };
  const dispatch = useAppDispatch();
  const [modalType, setModalType] = React.useState("");
  const [errors, setErrors] = useState<Partial<AccountDetailsValues>>({});
  const { profileData, isValidUser }: any = useAppSelector(
    (state) => state.ProfileState
  );
  const { updateLoader, emailVerificationLoader } = useAppSelector(
    (state) => state.ProfileState
  );
  const { email_verified } =
    useAppSelector((state) => state.ProfileState?.profileData?.data) || false;

  const [profileDatas, setProfileData] = useState(initialState);

  useEffect(() => {
    setProfileData(profileData?.data);
  }, [profileData]);

  const onModalSelection = (type: string, id?: any) => {
    let payload: any = profileData;

    dispatch(updateProfileDataAsync(payload));
    setModalType(type);
  };

  const onOpenModal = (type: string) => {
    setModalType(type);
  };

  const onCloseModal = () => {
    setModalType("");
  };

  const onNextClick = (active: any) => {
    dispatch(setStepperActiveMenu(active));
  };
  React.useEffect(() => {
    if (isValidUser && profileData?.data?.first_name) {
      onNextClick("address");
    }
  }, [isValidUser, profileData]);

  const saveDetails = () => {
    
    let payload: any = {
      first_name: profileDatas?.first_name,
      email: profileDatas?.email,
      email_verified: email_verified,
    };

    const baseErrors = AccountNameDetailsValidation(payload);

    // Validate email presence and format as well
    const curErrors: Partial<AccountDetailsValues> = { ...baseErrors };
    const emailVal = payload?.email?.toString().trim() || "";
    if (!emailVal) {
      curErrors.email = `Please enter a valid Email.`;
    } else {
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      if (!emailRegex.test(emailVal)) {
        curErrors.email = "Please enter a valid email address.";
      }
    }

    if (Object.keys(curErrors).length === 0) {
      // If user has entered an email but hasn't verified it yet,
    // block saving and prompt them to verify first.
    // if (profileDatas?.email && !email_verified) {
    //   dispatch(
    //     showSnackbar({
    //       message: "Please verify your email.",
    //       severity: "error",
    //       autoHide: 3000,
    //     })
    //   );
    //   return;
    // }
      dispatch(updateProfileDataAsync(payload)).then((response: any) => {
        if (response?.payload?.status === 200) {
          dispatch(
            showSnackbar({
              message: "Profile is updated succesfuly.",
              severity: "success",
              autoHide: 2000,
            })
          );
          dispatch(getProfileDataAsync());
        } else {
          // Try to surface server-side validation errors (e.g. duplicate email)
          const serverErrors = response?.payload?.data?.errors;
          if (serverErrors) {
            const newErrors: Partial<AccountDetailsValues> = { ...curErrors };
            if (serverErrors.email && Array.isArray(serverErrors.email)) {
              newErrors.email = serverErrors.email[0];
            }
            setErrors(newErrors);

            // also show snackbar with first server message if available
            const firstMsg = serverErrors.email
              ? serverErrors.email[0]
              : response?.payload?.data?.message;
            if (firstMsg) {
              dispatch(
                showSnackbar({
                  message: firstMsg,
                  severity: "error",
                  autoHide: 3000,
                })
              );
              return;
            }
          }

          dispatch(
            showSnackbar({
              message: "Please try again later.",
              severity: "error",
              autoHide: 3000,
            })
          );
        }
      });
    } else {
      setErrors(curErrors);
    }
  };
  const emailVarification = () => {
    dispatch(emailVarificationAsync(profileDatas?.email)).then((response: any) => {
      if (response?.payload?.status === 200) {
        dispatch(
          showSnackbar({
            message:
              "A verification email has been sent to your email address. Please click the link in that email to verify your account.",
            severity: "success",
            autoHide: 2000,
          })
        );
      } else {
        let errorMessage = response?.payload?.data?.message;
        dispatch(
          showSnackbar({
            message: errorMessage ? errorMessage : "Please try again later.",
            severity: "error",
            autoHide: 3000,
          })
        );
      }
    });
  };

  const inputChange = (event: React.ChangeEvent<HTMLInputElement>): void => {
    const { name, value } = event.target;

    setProfileData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
    let curErrors: Partial<AccountDetailsValues> = { ...errors };
    delete curErrors[name as keyof AccountDetailsValues];
    const fieldErrors: Partial<AccountDetailsValues> = AccountDetailsValidation(
      {
        ...profileData,
        [name]: value,
      }
    );
    if (fieldErrors[name as keyof AccountDetailsValues]) {
      curErrors[name as keyof AccountDetailsValues] =
        fieldErrors[name as keyof AccountDetailsValues];
    }
    setErrors(curErrors);
  };

  return (
    <>
      {!isValidUser ? (
        <div>
          <div>
            <p className="mb-3">
              To place your order now, login to your existing account or sign up
            </p>
            <button onClick={() => onOpenModal("login")} className="btn-prime">
              LOG IN
            </button>
          </div>

          <CustomDialog
            component={
              <LoginPart onClose={onCloseModal} isFromAccount={true} />
            }
            title="Login"
            openDialog={modalType === "login"}
            handleCloseDialog={onCloseModal}
            modalPlace="center"
          />
        </div>
      ) : !profileData?.data?.email || !profileData?.data?.first_name ? (
        <div>
          <div className="row">
            <p className="mb-3">
              Please provide the following details to proceed with your order.
            </p>
            <div className="col-md-6">
              <div className="tf-field style-1 mb_15">
                <CustomInput
                  label="First Name"
                  name="first_name"
                  required
                  size="small"
                  value={profileDatas?.first_name}
                  onChange={inputChange}
                  variant="outlined"
                  error={!!errors?.first_name}
                  fullWidth
                  helperText={errors?.first_name}
                />
              </div>
            </div>

            <div className="col-md-8">
              <div className="tf-field style-1 mb_15">
                <CustomInput
                  type="email"
                  label="Email"
                  name="email"
                  size="small"
                  value={profileDatas?.email}
                  onChange={inputChange}
                  variant="outlined"
                  required
                  error={!!errors?.email}
                
                  fullWidth
                  helperText={errors?.email}
                  // focused
                  loader={profileData?.loader}
                  endIcon={
                    email_verified ? (
                      <CheckCircleOutline color="success" />
                    ) : (
                      <Tooltip title="Please verify your email.">
                        <InfoIcon color="info" />
                      </Tooltip>
                    )
                  }
                  // InputProps={{
                  //   endAdornment: (
                  //     <InputAdornment position="end">
                  //       <CheckIcon />
                  //     </InputAdornment>
                  //   ),
                  // }}
                />
              </div>
            </div>
            {/* <div className="col-md-2">
              <div className="tf-field style-1 mb_15">
                <CustomButton
                  size="medium"
                  fullWidth
                  onClick={() => onModalSelection("changeEmail")}
                  name={profileDatas?.email ? "Edit Email" : "Add"}
                />
              </div>
            </div> */}
            <div className="col-md-2">
              <div className="tf-field style-1 mb_15">
                <CustomButton
                  loader={emailVerificationLoader}
                  color={email_verified ? "success" : "primary"}
                  endIcon={
                    email_verified ? (
                      <TaskAltIcon />
                    ) : (
                      <PublishedWithChangesIcon />
                    )
                  }
                  size="medium"
                  fullWidth
                  onClick={emailVarification}
                  name={email_verified ? "Verified" : "Verify"}
                />
              </div>
            </div>
          </div>

          <div className="row mt-4">
            <div className="col-md-8"></div>

            <CustomButton
              endIcon={<SaveIcon />}
              onClick={saveDetails}
              loader={updateLoader}
              size="large"
              fullWidth
              name="Save & Continue"
            />
          </div>

          <CustomDialog
            component={
              <ChangeEmail
                emailProp={profileData?.email}
                modalClose={onCloseModal}
                fromCheckout={true}
                setProfileData={setProfileData}
              />
            }
            title={profileData?.email ? "Change" : "Add"}
            openDialog={modalType === "changeEmail"}
            handleCloseDialog={onCloseModal}
            modalPlace="center"
          />
        </div>
      ) : null}
    </>
  );
};
